import '../css/Navbar.css'
import LocationSelector from "./LocationSelector";
import LocationCode from "../utils/constants/LocationCode";
import NavMenu from "./NavMenu";
import AdminMenuId from "../utils/constants/AdminMenuId";
import proxy from "../utils/Proxy";
import UserMenuId from "../utils/constants/UserMenuId";
import { useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { getDateString } from '../utils/Utils';

function Navbar(props) {
    let navbarRef = useRef();
    let isMobile = useMediaQuery({ maxWidth: 768 })
    let logout = () => {
        proxy.get("/api/logout").then(() => {
            props.onLoginChange(false)
        }).catch((error) => {
            props.onLoginChange(false)
        })
    }
    let outsideListener = (e) => {
        if (navbarRef && navbarRef.current !== null && !navbarRef.current.contains(e.target)) {
            setOpen(false)
            setTimeout(() => {
                document.removeEventListener('click', outsideListener);
            }, 200)
        }
    }
    let onClickSideButton = (_) => {
        if (navbarRef) {
            setOpen(true);
            window.addEventListener('resize', resizeHandler)
            setTimeout(() => {
                document.addEventListener('click', outsideListener);
            }, 200)
        }
    }
    let resizeHandler = (_) => {
        if (navbarRef) {
            setOpen(false);
            window.removeEventListener('resize', resizeHandler);
            document.removeEventListener('click', outsideListener);
        }
    }
    let setOpen = (isOpen) => {
        let keyframes = [
            { transform: isOpen ? "translate(0, 0)" : "translate(279px, 0)" },
            { transform: isOpen ? "translate(279px, 0)" : "translate(0, 0)" }
        ]
        let options = {
            delay: 0,
            duration: 200,
            easing: "ease-out",
            iterations: 1,
            fill: "forwards"
        }
        if (navbarRef.current !== null)
            navbarRef.current.animate(keyframes, options)
    }
    let menuClick = (menuid) => {
        props.onMenuChange(menuid)
        document.removeEventListener('click', outsideListener);
        window.removeEventListener('resize', resizeHandler);
        if (isMobile)
            setTimeout(() => {
                setOpen(false)
            }, 300)
    }
    return (
        <>
            <div className="navbar-header">
                <div className="navbar-side-button-container">
                    <div className="navbar-side-button"
                        onClick={(e) => onClickSideButton(e)}>
                    </div>
                </div>
                <div className="navbar-mobile-logo">
                    <p>Pianotogether</p>
                </div>
            </div>
            <div className="navbar-container" ref={navbarRef}>
                <div className="navbar-content-wrapper">
                    <div className="logo-wrapper">
                        <div className="logo"></div>
                        <div className="location-text-wrapper">
                            <p id="location-logo-text">{LocationCode.text[props.location]}</p>
                        </div>
                    </div>
                    {props.isAdmin ?
                        <>
                            <LocationSelector location={props.location}
                                onLocationChange={props.onLocationChange}></LocationSelector>
                            <NavMenu menuid={AdminMenuId.TABLE} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={true}></NavMenu>
                            <NavMenu menuid={AdminMenuId.USER_MANAGEMENT} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={true}></NavMenu>
                            <NavMenu menuid={AdminMenuId.TEACHER_MANAGEMENT} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={true}></NavMenu>
                            <NavMenu menuid={AdminMenuId.REGISTER_PAYMENT} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={true}></NavMenu>
                            <NavMenu menuid={AdminMenuId.QR_CODE} onMenuChange={menuClick.bind(this)}
                              currentMenu={props.currentMenu} isAdmin={true}></NavMenu>
                        </> : <>
                            <div className="user-info-container">
                                <div className="user-info-box">
                                    <p className="user-info-text">
                                        {props.myInformation.name + " (" +
                                            getDateString(new Date(props.myInformation.paymentStart), true) + " ~ " +
                                            getDateString(new Date(props.myInformation.paymentEnd), true) + ")"}
                                    </p>
                                </div>
                                <p className="user-info-lesson-count-text">
                                    {"잔여 레슨 수 : " +
                                        props.myInformation.lesson_count + "회"}
                                </p>
                            </div>
                            <NavMenu menuid={UserMenuId.TABLE} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={false}></NavMenu>
                            <NavMenu menuid={UserMenuId.MY_INFO} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={false}></NavMenu>
                            <NavMenu menuid={UserMenuId.LESSON_HISTORY} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={false}></NavMenu>
                            <NavMenu menuid={UserMenuId.PAYMENT_HISTORY} onMenuChange={menuClick.bind(this)}
                                currentMenu={props.currentMenu} isAdmin={false}></NavMenu>
                        </>
                    }
                </div>
                <div className="logout-button" onClick={logout}></div>
            </div>
        </>
    )
}

export default Navbar;
